import React from 'react';
import { Link } from 'react-router-dom';
import Counter from '../Counter';

const Hero = () => {
  return (
    <section id="hero" className="hero section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6" data-aos="fade-right" data-aos-delay="100">
            <div className="hero-content">
              <h1 data-aos="fade-up" data-aos-delay="50">Build, Migrate, and Scale with Rettiyon Global</h1>
              <p data-aos="fade-up" data-aos-delay="150">We build custom software, migrate workloads to the cloud, and integrate your systems—so your business can scale with reliable technology and clear delivery.</p>
              <div className="hero-buttons" data-aos="fade-up" data-aos-delay="250">
                <Link to="/contact" className="btn btn-primary">Get Started</Link>
                <Link to="/portfolio" className="btn btn-outline">Our Work</Link>
              </div>
              <div className="hero-stats" data-aos="fade-up" data-aos-delay="350">
                <div className="stat-item" data-aos="zoom-in" data-aos-delay="400">
                  <Counter end={150} duration={2} />
                  <span className="stat-label">Projects Completed</span>
                </div>
                <div className="stat-item" data-aos="zoom-in" data-aos-delay="500">
                  <Counter end={95} duration={2} suffix="%" />
                  <span className="stat-label">Client Satisfaction</span>
                </div>
                <div className="stat-item" data-aos="zoom-in" data-aos-delay="600">
                  <Counter end={24} duration={2} />
                  <span className="stat-label">Team Members</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6" data-aos="fade-left" data-aos-delay="200">
            <div className="hero-visual">
              <div className="hero-image">
                <img src="/images/misc-16.webp" alt="Digital Agency Hero" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hero-bg-elements">
        <div className="bg-shape shape-1"></div>
        <div className="bg-shape shape-2"></div>
        <div className="bg-particles"></div>
      </div>
    </section>
  );
};

export default Hero;
